import { mergeMap } from 'rxjs/operators';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { ClientAction } from '../client.action';
import { ClientTranslator } from '../client.translator';

type IDependencies = IClientApiDependencySegment;

export const updateClientEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ClientAction.update.started),
  mergeMap((params) => {
    const { payload, resolve, reject } = params;
    return dependencies.api.updateClient(ClientTranslator.toApi(payload)).pipe(
      mergeMap(() => {
        resolve?.();

        return [
          ClientAction.update.done({ params }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          ClientAction.update.failed({ params, error: null }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
